import React from 'react';
import CampaignsOverview from '../shared/CampaignsOverview';
import LoadCampaignDataButton from '../shared/LoadCampaignDataButton';

const OverviewTab = ({ 
    clientCampaigns, 
    convertTimestampsToDates, 
    onTableRowClick,
    tableValues,
    setTableValues,
    invoicingFilter,
    setInvoicingFilter,
    tableRerenderKey = 0,
    triggerTableRerender,
    loadAllCampaignsWithHistoryAndOpenBillingData
}) => {
    return (
        <div>
            <LoadCampaignDataButton
                clientCampaigns={clientCampaigns}
                loadAllCampaignsWithHistoryAndOpenBillingData={loadAllCampaignsWithHistoryAndOpenBillingData}
                triggerTableRerender={triggerTableRerender}
                tabName="Overview"
            />

        <CampaignsOverview
            clientCampaigns={clientCampaigns}
            convertTimestampsToDates={convertTimestampsToDates}
            onTableRowClick={onTableRowClick}
            tableValues={tableValues}
            setTableValues={setTableValues}
            invoicingFilter={invoicingFilter}
            setInvoicingFilter={setInvoicingFilter}
            columnsToShow="overview"
            tableRerenderKey={tableRerenderKey}
        />
        </div>
    );
};

export default OverviewTab; 